package pl.zar.tikthrow.util

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Instant

fun scheduledLocalDateTimeAtMillis(dateMillis: Long, hour: Int, minute: Int): Long {
    val date = Instant.fromEpochMilliseconds(dateMillis)
        .toLocalDateTime(TimeZone.UTC)
        .date
    return LocalDateTime(date, LocalTime(hour, minute))
        .toInstant(TimeZone.currentSystemDefault())
        .toEpochMilliseconds()
}
